import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-top-up-button',
  imports: [CommonModule],
  templateUrl: './top-up-button.component.html',
  styleUrl: './top-up-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopUpButtonComponent { 
  isVisible = false;

  // Listen to window scroll events
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isVisible = window.scrollY > 300; // Show button after 300px
  }

  // Scroll to top smoothly
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
